import React, {Fragment, useContext, useEffect, useState} from 'react';
import {Store} from "../../../app/stores/store-root";
import {Formik} from "formik";
import {Payment, PaymentFormValues} from "../../../app/models/payment";
import {
    EuiBreadcrumbs,
    EuiButton,
    EuiDescribedFormGroup,
    EuiFieldNumber,
    EuiForm,
    EuiFormRow,
    EuiLink,
    EuiPageContent,
    EuiPageContentHeader,
    EuiPageContentHeaderSection,
    EuiPanel,
    EuiSelect,
    EuiSpacer,
    EuiText,
    EuiTitle
} from "@elastic/eui";
import {v4 as uuidv4} from "uuid";
import {UserProfile} from "../../../app/models/user-profile";
import {observer} from 'mobx-react-lite';
import {useHistory} from 'react-router-dom';
import * as yup from 'yup';
import MessageModal from "../../../app/common/message-modal";

const PayBalanceForm = () => {
        const store = useContext(Store);
        const history = useHistory();
        const [payment, setPayment] = useState<Payment>(new PaymentFormValues());
        const [agents, setAgents] = useState<any[]>([]);
        const [selectedAgent, setSelectedAgent] = useState<UserProfile | undefined>(undefined);

        useEffect(() => {
            store.Agents.loadAgents();
        }, [store.Agents]);

        useEffect(() => {
            if (store.Agents.sendingAgents) {
                const transformed = store.Agents.sendingAgents.map((item: UserProfile) => {
                    return {text: `${item.Name} ${item.FamilyName} (${item.UserName})`, value: item.UserName}
                })
                if (transformed)
                    transformed.splice(0, 0, {text: 'Select an agent', value: ''});
                console.log('Transformed agents ', transformed);
                setAgents(transformed);
            }
        }, [store.Agents.sendingAgents])

        const onFormSubmit = (values: PaymentFormValues) => {
            values.CreatedAt = new Date();
            values.CreatedByName = `${store.Users.Name} ${store.Users.FamilyName}`;
            values.CreatedBySub = store.Users.Sub;
            values.CreatedByUserName = store.Users.UserName;
            values.Id = uuidv4();
            values.Sub = selectedAgent!.Id;
            values.UserName = selectedAgent!.UserName;

            if(values.Amount > selectedAgent!.Balance) {
                store.Modal.openModal(<MessageModal message={'Amount to pay cannot be more than agents balance.' +
                ' Agent' +
                ` Balance is ${selectedAgent?.CurrencySymbol}${selectedAgent?.Balance} , Amount to pay is ${selectedAgent?.CurrencySymbol}${values.Amount} `}
                                                    success={false}/>)

                return;
            }
            console.log('Paymeny ', values);

            store.Payments.MakePayment(values).then(()=>{
                store.Modal.openModal(<MessageModal message={'Payment successfully saved. The agent balance will be' +
                ' adjusted'} success={true}/>)
                history.push('/');
            }).catch((e)=>{
                store.Modal.openModal(<MessageModal message={'Unable to save this payment. The following error was' +
                ` encountered. ${e.response.data.error}`} success={false}/>)
            });
        }

        const onAgentChange = (e: any) => {
            const agentId = e.target.value;


            store.Agents.loadAgent(agentId).then((agent) => {
                console.log(agent);
                setSelectedAgent(agent)
            });
        }

        const breadcrumbs = [
            {
                text: "Remittance App",
                href: "#",
                onClick: (e: any) => {
                    e.preventDefault();
                },
                "data-test-subj": "breadcrumbsAnimals",
            },
            {
                text: "Agents",
                href: "#",
                onClick: (e: any) => {
                    e.preventDefault();
                },
            },

            {
                text: "Pay Balance",
            },
        ];

        const disabledPaymentBox = () => {
            if (!selectedAgent)
                return true;
            if (!(selectedAgent.Balance) || selectedAgent.Balance == 0)
                return true;
            return false;
        }

        const schema = yup.object().shape({
            UserName: yup.string().required('An agent must be selected'),
            Amount: yup.number().required('Amount is required').moreThan(0, 'Amount cannot be 0 or less')
        })

        return (
            <Fragment>
                <Formik initialValues={payment} onSubmit={onFormSubmit} validationSchema={schema}>
                    {
                        (formik) => (
                            <Fragment>
                                <EuiPageContent>
                                    <EuiBreadcrumbs
                                        breadcrumbs={breadcrumbs}
                                        truncate={false}
                                        aria-label="An example of EuiBreadcrumbs"
                                    />
                                    <EuiSpacer size="xs"/>
                                    <EuiPageContentHeader>
                                        <EuiPageContentHeaderSection>
                                            <EuiTitle size="l">
                                                <h1>Pay Balance</h1>
                                            </EuiTitle>
                                        </EuiPageContentHeaderSection>
                                    </EuiPageContentHeader>
                                </EuiPageContent>
                                <EuiSpacer/>
                                <EuiForm
                                    /*isInvalid={!formik.isValid && formik.submitCount > 0}
                                    error={_.values(formik.errors)}*/
                                >
                                    <form onSubmit={formik.handleSubmit}>
                                        <EuiPanel>
                                            <EuiDescribedFormGroup title={<h3>Balance</h3>}
                                                                   description={
                                                                       <Fragment>
                                                                           A single text field that can be used to display
                                                                           additional text. It
                                                                           can have{' '}
                                                                           <EuiLink href="http://www.elastic.co"
                                                                                    target="_blank">
                                                                               links
                                                                           </EuiLink>{' '}
                                                                           or any other type of content.
                                                                       </Fragment>
                                                                   }>
                                                <EuiFormRow label='First, select agent'
                                                            isInvalid={(formik.getFieldMeta('UserName').error && formik.getFieldMeta('UserName').touched) ? true : false}
                                                            error={formik.getFieldMeta('UserName').error}
                                                >
                                                    <EuiSelect
                                                        id={'UserName'}
                                                        name={'UserName'}
                                                        options={agents}
                                                        onChange={(e) => {
                                                            formik.getFieldHelpers('UserName').setValue(e.target.value)
                                                            onAgentChange(e)
                                                        }}
                                                        isInvalid={(formik.getFieldMeta('UserName').error && formik.getFieldMeta('UserName').touched) ? true : false}/>
                                                </EuiFormRow>
                                                {
                                                    (selectedAgent) ? (
                                                        <Fragment>
                                                            <EuiFormRow label='Current balance & limit'>
                                                                <Fragment>
                                                                    <EuiText size="s">Limit
                                                                        : {selectedAgent.Limit} </EuiText>
                                                                    <EuiText size="s">Balance
                                                                        : {selectedAgent.Balance ?? 'No' +
                                                                        ' Balance'} </EuiText>
                                                                </Fragment>
                                                            </EuiFormRow>
                                                            <EuiFormRow label='Payment'
                                                                        isInvalid={(formik.getFieldMeta('Amount').error && formik.getFieldMeta('Amount').touched) ? true : false}
                                                                        error={formik.getFieldMeta('Amount').error}
                                                            >
                                                                <EuiFieldNumber
                                                                    {...formik.getFieldProps('Amount')}
                                                                    prepend={selectedAgent?.CurrencySymbol}
                                                                    append={selectedAgent?.CurrencyLabel}
                                                                    disabled={disabledPaymentBox()}
                                                                    isInvalid={(formik.getFieldMeta('Amount').error && formik.getFieldMeta('Amount').touched) ? true : false}/>
                                                            </EuiFormRow>
                                                        </Fragment>
                                                    ) : ''
                                                }


                                            </EuiDescribedFormGroup>

                                        </EuiPanel>
                                        <div className="space-x-8 flex justify-end mt-4">
                                            <EuiButton
                                                size="s"
                                                fill
                                                type={"submit"}
                                                /* isDisabled={isSubmitting || readOnly}
                                                 isLoading={isSubmitting}*/
                                            >
                                                Submit
                                            </EuiButton>
                                            <EuiButton
                                                size="s"
                                                type={"button"}
                                                onClick={() => history.push("/")}
                                            >
                                                Back to dashboard
                                            </EuiButton>
                                        </div>
                                    </form>
                                </EuiForm>
                            </Fragment>
                        )
                    }
                </Formik>
            </Fragment>
        );
    }
;

export default observer(PayBalanceForm);